import { useMutation } from '@tanstack/react-query';
import type { AllowedMime, PresignUploadResponse } from '@bom/shared';
import { api } from '../lib/apiClient';

interface PresignBody {
  filename: string;
  content_type: AllowedMime;
  size_bytes: number;
  purpose?: 'version_attachment' | 'item_attachment' | 'approval_doc' | 'general';
}

export function usePresignUpload(tid: string) {
  return useMutation({
    mutationFn: (body: PresignBody) =>
      api.post<PresignUploadResponse>(`/tenants/${tid}/attachments/presign`, body),
  });
}

/** 直接 PUT 檔到 S3 預簽 URL（不經 apiClient：S3 URL 自帶簽章，毋需我們的 Authorization） */
export async function putFileToS3(
  uploadUrl: string,
  file: File,
  contentType: string,
): Promise<void> {
  const res = await fetch(uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': contentType },
    body: file,
  });
  if (!res.ok) throw new Error(`S3 upload failed: ${res.status}`);
}

/** 取下載 URL（帶 token）→ 新分頁開啟（後端回 JSON {download_url}） */
export async function openAttachment(tid: string, s3Key: string): Promise<void> {
  // {aid} path 參數後端忽略（以 ?key 為準），用佔位字串
  const r = await api.get<{ download_url: string }>(`/tenants/${tid}/attachments/file`, {
    query: { key: s3Key },
  });
  window.open(r.download_url, '_blank', 'noopener');
}
